'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import Location from '@icons/Location.svg';

import { InfoContainer } from '@components/Common';
import { Input } from '@components/Input';
import { Action } from '@components/Modal';
import { OnboardingStep } from '@components/Onboarding/TeacherOnboarding/components';
import {
  AddressContainer,
  AddressInputsContainer,
  LocationContainer,
} from '@components/Onboarding/TeacherOnboarding/styles';
import { FoundAddress } from '@components/Onboarding/TeacherOnboarding/types';
import { Text } from '@components/TextGroups';

interface AddressStepProps {
  postCodeInput: string;
  houseNumberInput: string;
  setPostCode: (value: string) => void;
  setHouseNumber: (value: string) => void;
  address: FoundAddress | null;
  error?: boolean;
}

export const AddressStep: React.FC<AddressStepProps> = ({
  postCodeInput,
  houseNumberInput,
  setPostCode,
  setHouseNumber,
  address,
  error,
}) => {
  const { t } = useTranslation('common');

  return (
    <OnboardingStep
      stepLabel={t('onboardingTeacher.stepFour')}
      title={t('onboardingTeacher.stepFourTitle')}
      description={t('onboardingTeacher.stepFourDescription')}>
      <AddressInputsContainer>
        <Input
          type="postCode"
          id="postCode"
          placeholder={t('onboardingTeacher.enterPostCode')}
          name="postCode"
          label={t('onboardingTeacher.postCode')}
          value={postCodeInput}
          onChange={(e) => setPostCode(e.target.value)}
          required
          hasError={!!error}
        />
        <Input
          type="houseNumber"
          id="houseNumber"
          placeholder={t('onboardingTeacher.enterHouseNumber')}
          name="houseNumber"
          label={t('onboardingTeacher.houseNumber')}
          value={houseNumberInput}
          onChange={(e) => setHouseNumber(e.target.value)}
          required
          hasError={!!error}
        />
      </AddressInputsContainer>
      {address && (
        <AddressContainer>
          <LocationContainer>
            <Location />
          </LocationContainer>
          <InfoContainer>
            <Action>
              {address?.street} {address?.houseNumber}
            </Action>
            <Text>
              {address?.postCode}, {address?.city}
            </Text>
          </InfoContainer>
        </AddressContainer>
      )}
    </OnboardingStep>
  );
};
